import { UtilityBar } from "@/components/organisms/UtilityBar";

export function DocumentsSubnav() {
  return (
    <>
      <UtilityBar />
    </>
  );
}
